import React from 'react'
import { MoreVertical } from 'lucide-react'
import { motion } from 'framer-motion'
import ShimmerEffect from '../ui/ShimmerEffect'

export default function DefaultersTable({ data = [], loading }) {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="p-4 border-b">
          <ShimmerEffect className="h-6 w-32" />
        </div>
        <div className="divide-y">
          {[1, 2, 3, 4, 5].map(i => (
            <div key={i} className="p-4">
              <ShimmerEffect className="h-12 w-full" />
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (!data.length) {
    return <p className="p-4 text-center text-gray-500">No defaulters data available</p>
  }

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="p-4 border-b">
        <h3 className="text-lg font-medium text-gray-900">Defaulters</h3>
      </div>
      <div className="divide-y">
        {data.map((student) => (
          <motion.div
            key={student.id}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="p-4 flex items-center justify-between hover:bg-gray-50"
          >
            <div className="flex items-center space-x-4">
              <div>
                <p className="text-sm font-medium text-gray-900">{student.id}</p>
                <p className="text-sm text-gray-500">{student.name}</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                student.defaultType === 'Fees' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'
              }`}>
                {student.defaultType}
              </span>
              <button className="text-gray-400 hover:text-gray-500">
                <MoreVertical className="h-5 w-5" />
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}